/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {backfillSavingsCashInActivity} from '../api'

export const useMutationBackfillSavingsCashInActivity = createReactQueryMutationHook('backfillSavingsCashInActivity', backfillSavingsCashInActivity)
